import _map from 'lodash/map';
import React, { Component } from 'react';
import { wobblyLineProps } from 'src/pages/slide';
import ResourceCard from '../resource-card/ResourceCard';
import { ResourcesFooter } from '../resources-footer/ResourcesFooter';
import { Button } from 'src/components/button/Button';
import './ResourcesSlide1.scss';

export class ResourcesSlide1 extends Component {
  componentDidMount() {
  }

  createTopCards() {
    return _map([
      {
        title: 'Get to know the Design Thinking Methods.',
        card: {
          title: 'Intro to Made for Humans',
          button:{
            label: 'Download the PDF',
            type: 'download',
            url: './downloads/made-for-humans.pdf',
            analytics: {
              category: 'resources',
              action: 'download',
              label: 'Intro to Made for Humans (pdf)',
            },
          },
          // link:{
          //   label: 'Book an introductory session',
          //   url: '',
          //   analytics: {
          //     category: 'resources',
          //     action: 'link',
          //     label: 'Intro to Made for Humans Session',
          //   },
          // },
        },
      },
      {
        title: 'Become a Design Champion by starting your own Design Sprint.',
        card: {
          title: 'Your first Design Sprint',
          button: {
            label: 'Download the PDF',
            type: 'download',
            url: './downloads/designsprint.pdf',
            analytics: {
              category: 'resources',
              action: 'download',
              label: 'Your first Design Sprint (pdf)',
            },
          },
          // link: {
          //   label: 'Book a Design Champion training session',
          //   url: '',
          //   analytics: {
          //     category: 'resources',
          //     action: 'link',
          //     label: 'Book a Design Champion training session',
          //   },
          // },
        }
      },
      {
        title: 'Contact the Functions Tech team directly.',
        card: {
          title: 'Get in touch',
          button: {
            label: 'Email us',
            type: 'email',
            url: 'mailto:designthinking@absa.africa',
            analytics: {
              category: 'resources',
              action: 'link',
              label: 'Email us',
            },
          },
        },
      },
    ], (section, i) =>
      <div className="ResourcesGrid-item" key={i}>
        <p className="ResourcesGrid-itemTitle">{section.title}</p>
        <ResourceCard {...section.card} />
      </div>
    );
  }

  createOtherCards() {
    return _map([
      {
        title: 'Online training by ARO',
        link: { label: 'visit website', url: 'https://absagroup.csod.com/LMS/LoDetails/DetailsLo.aspx?loid=ff2330c4-acf1-4a63-8662-8d4ca44e4934&query=%23q%3Ddesign%2520thinking%26s%3D1%26a%3D&back_key=1#t=1' },
        analytics: {
          category: 'resources',
          action: 'link',
          label: 'Online training by ARO (training)',
        },
      },
      {
        title: 'Online training by CIB',
        link: { label: 'visit website', url: 'https://absagroup.csod.com/LMS/LoDetails/DetailsLo.aspx?loid=ab0fa83b-015c-40f5-b867-defdf0c1e866&query=%3Fs%3D1%26q%3DDesign%2520Thinking%2520&back_key=1#t=1' },
        analytics: {
          category: 'resources',
          action: 'link',
          label: 'Online training by CIB',
        },
      },
      {
        title: 'List of online resources',
        link: { label: 'visit website', url: 'https://miro.com/app/board/o9J_kxPIaLE=/' },
        analytics: {
          category: 'resources',
          action: 'link',
          label: 'List of online resources',
        },
      },
    ], (card, i) =>
      <div className="ResourcesGrid-item" key={i}>
        <ResourceCard {...card} />
      </div>
    );
  }

  render() {
    const topCards = this.createTopCards();
    const otherCards = this.createOtherCards();
    return (
      <div className="ResourcesSlide1" {...wobblyLineProps(this.props)}>

        <div className="Page-slide">
          <div className="Page-content">
            <div>
              <h2 className="Page-heading">How to get started</h2>
              <div className="ResourcesGrid">
                {topCards}
              </div>
            </div>

            <div>
              <h2 className="Page-heading">Other useful resources</h2>
              <div className="ResourcesGrid">
                {otherCards}
              </div>
            </div>

          </div>
        </div>
        <ResourcesFooter />
      </div>
    )
  }
}
